import Pirates from './Pirates'

export default Pirates
